export default __webpack_public_path__ + "static/media/expenseTracker.ca01e10e.png";